import React from "react";
import { Line, Rect } from "react-konva";

export default function WallColumnNone({
    position,
    lanterns,
    colorList,
    luminaires,
    props,
    barCenter,
    rotateAround,
    centerOffset,
    barThickness,
    fullArmLength,
    endPointSize,
}) {
    return lanterns.map((lantern, idx) => {
        const offset = (parseFloat(lantern.offset) || 0) - centerOffset;

        const luminaireIndex = luminaires.indexOf(lantern.luminaireId);
        const resolvedColor =
            luminaireIndex !== -1 && colorList[luminaireIndex]
                ? colorList[luminaireIndex]
                : "lightgray";

        const outreach = props.values.useLanternOutreach ? lantern.outreach : props.values.outreach || 0;
        const effectiveArmLength = fullArmLength * Math.max(1, outreach);
        const rectArmLength = fullArmLength * Math.max(0, outreach);

        const armX = offset;
        const armY = -barThickness / 2;
        const armTipX = armX;
        const armTipY = armY - effectiveArmLength;
        const rectX = armX;
        const rectY = armY - rectArmLength;

        const angle = props.positionAngle || 0;
        const angleRad = (angle * Math.PI) / 180;

        const baseRot = rotateAround({ x: barCenter.x + armX, y: barCenter.y + armY }, barCenter, angleRad);
        const armTipRot = rotateAround({ x: barCenter.x + armTipX, y: barCenter.y + armTipY }, barCenter, angleRad);
        const rectRot = rotateAround({ x: barCenter.x + rectX, y: barCenter.y + rectY }, barCenter, angleRad);

        return (
            <React.Fragment key={idx}>
                <Line
                    points={[baseRot.x, baseRot.y, armTipRot.x, armTipRot.y]}
                    stroke={resolvedColor === '#FFA500 ' ? "orange" : resolvedColor}
                    strokeWidth={endPointSize / 4}
                />
                <Rect
                    x={rectRot.x}
                    y={rectRot.y}
                    width={endPointSize}
                    height={endPointSize}
                    fill={resolvedColor === '#FFA500 ' ? "orange" : resolvedColor}
                    rotation={angle}
                    offset={{ x: endPointSize / 2, y: endPointSize / 2 }}
                />
            </React.Fragment>
        );
    });
}
